var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { withSkeleton } from '../../Skeleton';
import { OwnSkeleton, truncateStyle } from '../styles';
import { useProductLayout } from '../../ProductLayoutProvider';
var NameWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: calc(\n    ", " - ", "px\n  );\n  font-weight: normal;\n  line-height: inherit;\n  margin: 0.3rem 0;\n  padding: 0 0.5rem;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", ";\n"], ["\n  font-size: calc(\n    ", " - ", "px\n  );\n  font-weight: normal;\n  line-height: inherit;\n  margin: 0.3rem 0;\n  padding: 0 0.5rem;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.global.baseFontSize;
}, function (_a) {
    var big = _a.big;
    return (big ? 0 : 3);
}, function (_a) {
    var truncate = _a.truncate;
    return (truncate ? truncateStyle : '');
});
var ProductName = function (_a) {
    var name = _a.name, nameNoBrand = _a.nameNoBrand;
    var productLayoutConfig = useProductLayout().productLayoutConfig;
    return (React.createElement(React.Fragment, null,
        name && (React.createElement(NameWrapper, { truncate: productLayoutConfig.truncateStrings, "data-testid": "productName", big: true }, name)),
        nameNoBrand && (React.createElement(NameWrapper, { truncate: productLayoutConfig.truncateStrings, "data-testid": "productNameNoBrand" }, nameNoBrand))));
};
export default withSkeleton(ProductName, function () { return React.createElement(OwnSkeleton, { width: "90%" }); });
var templateObject_1;
//# sourceMappingURL=index.js.map